import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-block',
    width: 0,
    height: 0,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderStyle: 'solid',
  },
  sm: {
    borderLeftWidth: '4px',
    borderRightWidth: '4px',
    borderBottomWidth: '5px',
    borderTopWidth: '5px',
  },
  md: {
    borderLeftWidth: '8px',
    borderRightWidth: '8px',
    borderBottomWidth: '10px',
    borderTopWidth: '10px',
  },
  lg: {
    borderLeftWidth: '12px',
    borderRightWidth: '12px',
    borderBottomWidth: '15px',
    borderTopWidth: '15px',
  },
  up: {
    borderTopWidth: '0 !important',
    borderBottomColor: theme.palette.error.main,
  },
  down: {
    borderBottomWidth: '0 !important',
    borderTopColor: theme.palette.info.main,
  },
  middle: {
    borderLeftWidth: '10px',
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderTopWidth: '1px',
    borderColor: theme.palette.black,
  }
}));

const StatusArrow = props => {
  const {className, size, type, ...rest} = props;

  const classes = useStyles(props);

  return (
    <span
      {...rest}
      className={clsx(
        {
          [classes.root]: true,
          [classes[size]]: size,
          [classes[type]]: type,
        },
        className,
      )}
    />
  );
};

StatusArrow.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  type: PropTypes.oneOf([
    'up',
    'down',
    'middle',
  ]),
};

StatusArrow.defaultProps = {
  size: 'md',
  type: 'up',
};

export default StatusArrow;
